import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class SubServicioService {
  async getSubServiciosAll() {
    const subservicios = await fetchWrapper.get(`${ruta}/subservicios`);
    return subservicios;
  }

  async saveSubServicio(subservicios) {
    const newSubService = await fetchWrapper.post(
      `${ruta}/subservicios`,
      subservicios
    );
    return newSubService;
  }
  async updatedSubServicio(subservicios) {
    const updateSubService = await fetchWrapper.put(
      `${ruta}/subservicios/` + subservicios.id,
      subservicios
    );
    return updateSubService;
  }

  async eliminarSubServicio(id) {
    return await fetchWrapper.delete(`${ruta}/subservicios/${id}`);
  }
}
